module.exports = __webpack_public_path__ + "img/jigou1.52f86b63.png";